import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

/**
 * ### **CitiesSkeletonComponent**
 *
 * **Selector:** ``<app-cities-skeleton>``
 *
 * Un componente es un bloque, que contiene un template, contiene estilos y contiene la lógica, en este caso es el Componente
 * encargado de renderizar el esqueleto de precarga para la lista de ciudades.
 */
@Component({
  selector: 'app-cities-skeleton',
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./cities-skeleton.component.html",
  styleUrl: "./cities-skeleton.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CitiesSkeleton implements OnInit {
  /** Variable de entrada que recibe del componente padre el numero de objetos que debe renderizar*/
  readonly numbersLoading = input.required<number>();
  /** VAriable que guarda la lista de iteradores*/
  protected readonly numbersIterate = signal<number[]>([]);

  /** @ignore*/
  constructor() {}

  /**
   * Función nativa de angular que se carga despues del constructor si no hay un onChanges,
   * aqui incializa el valor de numbersIterate.
   */
  ngOnInit() {
    this.numbersIterate.set(
      Array(this.numbersLoading())
        .fill(0)
        .map((x, i) => i),
    );
  }
}
